import React from 'react'
import { NavLink } from 'react-router-dom'

const SubNav = ({items, onNav, currentPath}) => (
  <nav className="subnav">
    {items && items.map((item, i) => {
      let active = false;
      if(item.parent) {
        if(currentPath === item.parent || currentPath.indexOf(item.parent+'/') === 0) {
          active = true;
        }
      }
      if (!item.hidden) {
        return(
          <NavLink className={active?'active':null} activeClassName={item.disableActive?'':'active'} exact={item.disableActive} to={item.link} key={`navlink_${i}`} onClick={() => (onNav())}>{item.title}</NavLink>
        )
      }
      return null;
    })}
  </nav>
);

export default SubNav


// WEBPACK FOOTER //
// ./src/components/SubNav.js